import type { TypeFilterOptions } from './filter-option-keys';

export class LinkedMapItem {
    public name: string;
    public type: TypeFilterOptions;
    public id: number;
    public uniqueId: string;
    public sports: Array<string>;

    constructor({
                    name,
                    type,
                    id,
                    sports,
                }: Omit<LinkedMapItem, 'uniqueId'>) {
        this.name = name;
        this.type = type;
        this.id = id;
        this.sports = sports;
        this.uniqueId = `id-${ id }-type-${ type }`;
    }
}
